import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-114" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-115" data-mp="1dxjhpcxccxci">
        <SectionHeading id="modules-title" data-id="element-116" data-mp="1duni7k5ui0ly">The {totalVolumes} <span className="text-amber-400" data-id="element-117" data-mp="2bj7fa15j9lpm">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-118" data-mp="26km9lm7ii9ts">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl border border-slate-800 bg-slate-900 p-6 shadow-sm" data-id="element-119" data-mp="21nvxtb2qq0e6" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-120" data-mp="1nttj3a8cd8hu">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-500/10 text-orange-400" data-id="element-121" data-mp="18xkled43n37j">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-122" data-mp="1dukpwjlavxwj" />
                  </span>
                  <p className="text-sm font-semibold text-amber-400" data-id="element-123" data-mp="103z70uvujnyn">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-lg font-semibold leading-snug text-white" data-id="element-124" data-mp="14ws9fc3uek7k">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-125" data-mp="q8e855m2r3t4">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}